import { PageContainer } from "src/components/organisms/contents";
import { useLocation, useNavigate } from "react-router-dom";
import giftImg from "../../../styles/assets/img/shop_giftImg.png";
import { showAlert } from "src/components/containers/Alert";
import { SubConHeader } from "src/components/atoms/SubHeaderBox/SubConHeader";

export const PointGiftDetail = () => {
  const navi = useNavigate();
  const { state } = useLocation();

  const handleSave = async () => {
    const isConfirm = await showAlert("이미지가 저장 되었습니다.");

    if (isConfirm === true) {
      navi("/point");
    }
  };
  return (
    <PageContainer isNavBar={false} active={null} $bgColor={"#fff"}>
      <>
        {/* 헤더 */}
        <SubConHeader
          title="상세보기"
          $bgColor="#fff"
          onClickArrow={() => navi(-1)}
        />

        {/* 상품 정보 */}
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            padding: "16px 0 90px",
            gap: 16,
          }}
        >
          <div style={{ width: "100%" }}>
            <div
              style={{
                width: "100%",
                // height: "594px",
                objectFit: "cover",
              }}
            >
              <img
                src={giftImg}
                alt={state.name}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </div>

            {/* 결제·사용 조건 */}
            <div style={{ width: "100%", padding: "16px 0" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  gap: 16,
                  fontSize: 14,
                  fontWeight: 500,
                  lineHeight: "20px",
                  color: "#737373",
                }}
              >
                <span
                  style={{
                    fontSize: 16,
                    fontWeight: 700,
                    lineHeight: "24px",
                    color: "#404040",
                  }}
                >
                  결제·사용 조건
                </span>
                <ul>
                  <li
                    style={{
                      fontWeight: 700,
                      color: "#404040",
                      marginBottom: 8,
                    }}
                  >
                    영수증 및 결제 안내
                  </li>
                  <li>
                    - 본 상품은 루틴케어 리워드 포인트로 교환된 모바일
                    쿠폰이므로, 현금영수증 및 세금계산서 발급 대상이 아닙니다.
                  </li>
                  <li>
                    - 음료 수령 시 일부 매장에서 간이 영수증 제공은 가능하며,
                    정확한 발급 여부는 매장 정책에 따릅니다.
                  </li>
                </ul>
                <ul>
                  <li
                    style={{
                      fontWeight: 700,
                      color: "#404040",
                      marginBottom: 8,
                    }}
                  >
                    사용 가능 매장 안내
                  </li>
                  <li>
                    - 본 쿠폰은 전국 스타벅스 매장에서 사용 가능하며, 단, 일부
                    매장(인천공항점, 병원점, 고속도로휴게소 등)에서는 사용이
                    제한될 수 있습니다.
                  </li>
                  <li>
                    - 자세한 사용 가능 매장은{" "}
                    <a
                      href="https://www.starbucks.co.kr"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#404040", textDecoration: "underLine" }}
                    >
                      스타벅스 공식 홈페이지
                    </a>
                    에서 확인해주세요.
                  </li>
                </ul>
              </div>
            </div>

            {/* 하단 버튼 */}
            <div
              style={{
                width: "100%",
                maxWidth: "45rem",
                padding: 16,
                bottom: 0,
                position: "fixed",
                background: "white",
                borderTop: "1px rgba(0, 0, 0, 0.05) solid",
                display: "flex",
                flexDirection: "column",
                gap: 10,
                boxSizing: "border-box",
                left: "50%",
                transform: "translateX(-50%)",
              }}
            >
              <button
                style={{
                  alignSelf: "stretch",
                  height: 48,
                  background: "#F57C00",
                  borderRadius: 8,
                  border: "none",
                  cursor: "pointer",
                  fontSize: 16,
                  color: "white",
                }}
                onClick={handleSave}
              >
                이미지 저장하기
              </button>
            </div>
          </div>
        </div>
      </>
    </PageContainer>
  );
};
